import CloseIcon from '@mui/icons-material/Close';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { Box, Button, IconButton, TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'hooks/redux';
import React from 'react';
import { getText } from 'services/languageService';
import { setSearchRequestAction } from 'store/actions/searchTab';

export const AuthSearchBlock: React.FC<{
  search: () => void;
}> = ({ search }) => {
  const { searchRequest } = useAppSelector((state) => state.searchTab);

  const dispatch = useAppDispatch();

  const onChangeRequest = (event) => {
    dispatch(setSearchRequestAction(event.target.value));
  };

  const resetSearchBlock = () => {
    dispatch(setSearchRequestAction(''));
  };

  return (
    <Box sx={{ display: 'flex', p: '0 16px' }}>
      <TextField
        value={searchRequest}
        onChange={onChangeRequest}
        fullWidth
        size="small"
        autoComplete="off"
        placeholder={getText('SEARCH')}
      />
      <Box
        sx={{
          backgroundColor: (theme) => theme.palette.primary.main,
          borderRadius: '4px',
          mr: 1,
          ml: 1,
        }}
      >
        <IconButton sx={{ color: 'white' }} onClick={search}>
          <SearchRoundedIcon />
        </IconButton>
      </Box>
      <IconButton onClick={resetSearchBlock}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export const NoAuthSearchBlock: React.FC<{
  search: () => void;
}> = ({ search }) => {
  return (
    <Box sx={{ display: 'flex', p: '0 16px' }}>
      <Button variant="contained" fullWidth onClick={search}>
        {getText('SEARCH_TL')}
      </Button>
    </Box>
  );
};
